import { render } from "./backDatedCheques.vue?vue&type=template&id=5a48343e&ts=true"
import script from "./backDatedCheques.vue?vue&type=script&lang=ts"
export * from "./backDatedCheques.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__